import React from 'react';
import { Row } from 'react-bootstrap';
import Breadcrumb from '../../../components/Breadcrumb';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import AddEditNamkeenOrderForm from './AddEditNamkeenOrderForm';

const FestivalNamkeenOrders = () => {
  return (
    <>
      <ToastContainer />
      <Row className="px-2">
        <Breadcrumb
          navigation={[
            { link: '/cake/home', title: 'Home' },
            { link: '#', title: 'Namkeen Order' },
          ]}
        />
        <div>
          <Link to={'/cake/home'} className="text-decoration-none">
            <button className="btn app-btn-primary mb-3 me-5">&larr; Back</button>
          </Link>
          <Link to={'/cake/namkeen-orders'} className="text-decoration-none">
            <button className="btn app-btn-primary mb-3 me-5" style={{ float: 'right' }}>
              Orders
            </button>
          </Link>
        </div>
        <AddEditNamkeenOrderForm />
      </Row>
    </>
  );
};

export default FestivalNamkeenOrders;
